import { Link } from "react-router-dom";
import { hasApprovedWindowsRelease } from "@/lib/windowsReleases";

export default function WindowsEditionAvailability({ product }) {
  const live = hasApprovedWindowsRelease(product);
  return <div className="border border-white/20 px-5 py-6 text-white" data-testid={`${product}-windows-availability`}>
    <span className="font-mono text-[9px] uppercase tracking-[.2em] text-cyan-200">Windows edition</span>
    <p className="mt-2 text-sm text-slate-300">Windows 10/11 · x64. Website licence and signed in-app updates.</p>
    {live ? <Link className="lf-btn mt-4 border border-cyan-300 text-cyan-200" to="/account?platform=windows">Get the Windows app</Link>
      : <p className="mt-4 text-sm text-slate-300" role="status">Coming soon for Windows</p>}
  </div>;
}
